import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "drawer-content shortcut-form" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "fields" }
const _hoisted_6 = {
  key: 0,
  class: "icon icon-ok"
}
const _hoisted_7 = {
  key: 0,
  class: "icon icon-ok"
}
const _hoisted_8 = {
  key: 0,
  class: "icon icon-ok"
}
const _hoisted_9 = {
  key: 0,
  class: "icon icon-ok"
}
const _hoisted_10 = { class: "fields" }
const _hoisted_11 = {
  key: 0,
  class: "icon icon-ok"
}
const _hoisted_12 = {
  key: 0,
  class: "icon icon-ok"
}
const _hoisted_13 = { class: "buttons" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_16 = ["textContent"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cancel", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 2 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "Did you mean?", -1)

import { PropType, computed, onMounted, reactive, watch } from "vue";
import { useStore } from "vuex";
import useVuelidate from "@vuelidate/core";
import { Actions, Mutations } from "@/store";
import { Shortcut, shortcutValidations } from "@/models/shortcut";
import Loading from "@/components/common/Loading.vue";
import Field from "@/components/common/Field.vue";
import { useLoading } from "../common/loading.composable";
import FieldLong from "../common/FieldLong.vue";
import FieldChoice, { Item } from "../common/FieldChoice.vue";
import { Application } from "@/models/application";
import { DrawerActions } from "@/stores/drawer.store";
import { useEvents, Event } from "@/core/services/events.composable";
import { router } from "@/router";
import ShortcutKey from "./ShortcutKey.vue";
import ShortcutAddForm from "./ShortcutAddForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortcutForm',
  props: {
  data: {
    type: Object as PropType<{ application: number; shortcuts: Shortcut[] }>
  }
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const events = useEvents();

const props = __props;

const s = computed<Shortcut>(() => store.state.shortcut);

watch(
  () => store.state.shortcut,
  (v) => {
    Object.assign(shortcut, {
      ...v
    });
  }
);

const relatedShortcuts = computed<Shortcut[]>(() => {
  return store.state.shortcuts.filter(
    (s: Shortcut) =>
      s.application_id === shortcut.application_id &&
      s.shortcut_key.toLowerCase() === shortcut.shortcut_key.toLowerCase() &&
      !!s.ctrl_key === !!shortcut.ctrl_key &&
      !!s.alt_key === !!shortcut.alt_key &&
      !!s.shift_key === !!shortcut.shift_key &&
      !!s.command_key === !!shortcut.command_key
  );
});

const shortcut = reactive<Shortcut>({
  ...store.state.shortcut
});
const isNew = computed<boolean>(() => shortcut.id === -1);
const typeOptions: Item[] = [
  {
    label: "Shortcut",
    value: "shortcut"
  },
  {
    label: "Modifier",
    value: "modifier"
  }
];
const applicationOptions = computed<Item[]>(() => [
  { label: "None", value: undefined },
  ...store.state.applications.map((app: Application) => ({
    label: app.name,
    value: app.id
  }))
]);
const modeOptions = computed<Item[]>(() => {
  const application = store.state.applications.find(
    (app: Application) => app.id === shortcut.application_id
  );
  const modes = application?.modes || [];

  return [
    { label: "None", value: undefined },
    ...modes.map((mode: string) => ({
      label: mode,
      value: mode
    }))
  ];
});

const { loading, setLoading } = useLoading();

onMounted(() => {
  store.dispatch(Actions.GetApplications);
  store.dispatch(Actions.GetShortcuts);

  if (s.value?.id !== -1 && s.value) {
    Object.assign(shortcut, { ...s.value });
  } else {
    store.dispatch(Actions.NewShortcut);
  }
  if (props.data?.application || store.state.shortcut) {
    const application_id =
      props.data?.application || store.state.shortcut.application_id;

    Object.assign(shortcut, { ...store.state.shortcut, application_id });
  }
});

const $v = useVuelidate(shortcutValidations, { shortcut });
const emit = __emit;

const submit = async () => {
  $v.value.$touch();
  if (!$v.value.$invalid) {
    setLoading(true);
    await store.dispatch(Actions.StoreShortcut, shortcut);

    events.emit(Event.ShortcutCreated, null);

    store.dispatch(DrawerActions.CloseDrawer);

    setLoading(false);
    cancel();
  }
};

const cancel = () => {
  if (props.data) {
    emit("close");
  } else {
    router.push(`/shortcut/${shortcut.id}`);
  }
};

const choose = (choice: Shortcut) => {
  if (choice) {
    store.commit(Mutations.SetShortcut, choice);
    events.emit(Event.ShortcutCreated, null);
    store.dispatch(DrawerActions.CloseDrawer);
    cancel();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(ShortcutAddForm, {
      onChoose: choose,
      shortcuts: props.data?.shortcuts
    }, null, 8, ["shortcuts"]),
    shortcut
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: _normalizeClass({ submitting: _unref(loading) })
        }, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(isNew.value ? 'Add shortcut' : 'Edit shortcut')
          }, null, 8, _hoisted_2),
          (isNew.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Fill out the details of the shortcut"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "Edit the details of the shortcut")),
          _createVNode(Field, {
            label: "Name",
            validation: _unref($v).shortcut.name,
            modelValue: shortcut.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((shortcut.name) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldChoice, {
            label: "Type",
            modelValue: shortcut.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shortcut.type) = $event)),
            items: typeOptions
          }, null, 8, ["modelValue"]),
          _createVNode(FieldLong, {
            label: "Description",
            validation: _unref($v).shortcut.description,
            modelValue: shortcut.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shortcut.description) = $event)),
            styling: "field-text"
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldChoice, {
            label: "Application",
            modelValue: shortcut.application_id,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shortcut.application_id) = $event)),
            items: applicationOptions.value
          }, null, 8, ["modelValue", "items"]),
          _createVNode(FieldChoice, {
            label: "Mode",
            modelValue: shortcut.mode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((shortcut.mode) = $event)),
            items: modeOptions.value
          }, null, 8, ["modelValue", "items"]),
          _createVNode(Field, {
            label: "Shortcut Key",
            validation: _unref($v).shortcut.shortcut_key,
            modelValue: shortcut.shortcut_key,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shortcut.shortcut_key) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (shortcut.ctrl_key = !shortcut.ctrl_key))
            }, [
              (shortcut.ctrl_key)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                : _createCommentVNode("", true),
              _createTextVNode("Ctrl ")
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (shortcut.alt_key = !shortcut.alt_key))
            }, [
              (shortcut.alt_key)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                : _createCommentVNode("", true),
              _createTextVNode("Alt ")
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (shortcut.shift_key = !shortcut.shift_key))
            }, [
              (shortcut.shift_key)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                : _createCommentVNode("", true),
              _createTextVNode("Shift ")
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (shortcut.command_key = !shortcut.command_key))
            }, [
              (shortcut.command_key)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                : _createCommentVNode("", true),
              _createTextVNode("Command ")
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (shortcut.left_mouse_button = !shortcut.left_mouse_button))
            }, [
              (shortcut.left_mouse_button)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true),
              _createTextVNode("LMB ")
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (shortcut.right_mouse_button = !shortcut.right_mouse_button))
            }, [
              (shortcut.right_mouse_button)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                : _createCommentVNode("", true),
              _createTextVNode("RMB ")
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "confirm",
              type: "button",
              disabled: _unref(loading),
              onClick: submit
            }, [
              _hoisted_15,
              _createElementVNode("span", {
                class: "text",
                textContent: _toDisplayString(isNew.value ? 'Add' : 'Edit')
              }, null, 8, _hoisted_16)
            ], 8, _hoisted_14),
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: cancel
            }, _hoisted_18),
            (_unref(loading))
              ? (_openBlock(), _createBlock(Loading, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          (relatedShortcuts.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedShortcuts.value, (related) => {
                    return (_openBlock(), _createElementBlock("li", null, [
                      _createVNode(ShortcutKey, { shortcut: related }, null, 8, ["shortcut"])
                    ]))
                  }), 256))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 34))
      : _createCommentVNode("", true)
  ]))
}
}

})